





































































































































































































































import i18n from 'vue-i18n';

import EventBus from '@/eventBus';
import axios from 'axios';
import { get, uniq, map, upperFirst, toLower, clone, find } from 'lodash';
import JSConfetti from 'js-confetti';
import { getTicketPurchaseStatusLabelKey } from '@/utils/ticketPurchaseStatus';
import CoRoundButton from '@/components/Atoms/co-round-button/CoRoundButton.vue';
import CoHeadline from '@/components/Atoms/co-headline/CoHeadline.vue';
import CoCard from '@/components/Molecules/co-card/CoCard.vue';
import CoInput from '@/components/Molecules/co-input/CoInput.vue';
import CoLink from '@/components/Atoms/co-link/CoLink.vue';
import CoUser from '@/components/Molecules/co-user/CoUser.vue';
import CoConfirmation from '@/components/Molecules/co-confirmation/CoConfirmation.vue';

const jsConfetti = new JSConfetti();

export default {
    name: 'ViewEventParticipants',
    i18n: {
        messages: {
            en: {
                labels: {
                    ticketssold: 'Tickets Sold',
                    sum: 'Sum',
                    updateEvent: 'Update Event Details',
                    drafteventheadline: 'This event is in a draft mode',
                    eventVisability: 'Visibility',
                    publiceventheadline: 'This event is public and visible to everyone',
                    communityeventheadline: 'This event is visible to community members only',
                    draft: 'Draft',
                    public: 'Public',
                    communityOnly: 'Community Only',
                    closePreviewAsMember: 'Close Preview',
                    previewAsMember: 'Preview as Member',
                    addsection: 'Add Section',
                    textSection: 'Text Section',
                    imageSection: 'Image Section',
                    cancelattendance: 'Cancel attendance',
                    addaddress: 'Add a new address',
                    getticket: 'Get Ticket',
                    google: 'Google',
                    outlook: 'Outlook',
                    ics: 'ICS',
                    dragdropimage: 'Drag an image here or click to select.',
                    suggestedsizes: 'Suggested size 1280x720px (16:9)',
                    savetocalendar: 'save to calendar',
                    noupdatesyet: 'Be the first to post something',
                    posts: 'Posts',
                    removeParticipant: 'Remove participant',
                    removeOrganizer: 'Remove organizer',
                },

                messages: {
                    cancelmessage: 'Are you sure about this? This event would be much nicer with you!',
                    makePublic: 'Event will be visible to everyone outside the community.',
                    communityOnly: 'Event will be visible only to community members.',
                    deleteImageHeaderWarning: 'Are you sure you want to delete the header image?',
                    draftEvent: 'Event will be saved as a draft making it hidden.',
                    eventdeleted: 'Event has been deleted.',
                    noupdatesyet: 'Be the first to post something',
                    ticketRefundRelatedDescription:
                        'The following tickets were purchased together and can therefore only be canceled and refunded together.',
                    removeParticipantWarning: 'Are you sure you want to remove this participant from the event?',
                    removeOrganizerWarning: 'Are you sure you want to remove this organizer from the event?',
                },
            },
            de: {
                labels: {
                    sum: 'Summe',
                    ticketssold: 'Verkaufte Tickets',
                    addaddress: 'Neue Adresse hinzufügen',
                    updateEvent: 'Veranstaltungsdetails aktualisieren',
                    drafteventheadline: 'Dieses Event ist im Entwurfsmodus',
                    eventVisability: 'Sichtbarkeit',
                    publiceventheadline: 'Dieses Event ist öffentlich und für alle sichtbar',
                    communityeventheadline: 'Dieses Event ist nur für Community-Mitglieder sichtbar',
                    draft: 'Entwurf',
                    public: 'Öffentlich',
                    communityOnly: 'Nur für die Community',
                    closePreviewAsMember: 'Vorschau schließen',
                    previewAsMember: 'Vorschau als Mitglied',
                    addsection: 'Abschnitt hinzufügen',
                    textSection: 'Textabschnitt',
                    imageSection: 'Bildabschnitt',
                    cancelattendance: 'Teilnahme absagen',
                    getticket: 'Tickets',
                    dragdropimage: 'Ziehe ein Bild hierher oder klicke zum Auswählen',
                    suggestedsizes: 'Empfohlene Größe 1280x720px (16:9)',
                    savetocalendar: 'in Kalender speichern',
                    noupdatesyet: 'Sei die erste Person, die etwas postet',
                    posts: 'Beiträge',
                    removeParticipant: 'Teilnehmende entfernen',
                    removeOrganizer: 'Organisator:in entfernen',
                },

                messages: {
                    cancelmessage:
                        'Bist du dir sicher, dass du das willst? Diese @:labels.event wäre viel schöner mit dir!',
                    makePublic: 'Die Veranstaltung wird für alle außerhalb der Community sichtbar.',
                    communityOnly: 'Die Veranstaltung wird nur für Community-Mitglieder sichtbar.',
                    deleteImageHeaderWarning: 'Möchtest du das Titelbild wirklich löschen?',
                    draftEvent: 'Die Veranstaltung wird als Entwurf gespeichert und versteckt.',
                    eventdeleted: 'Die Veranstaltung wurde gelöscht.',
                    noupdatesyet: 'Sei die erste Person, die etwas postet',
                    ticketRefundRelatedDescription:
                        'Die folgenden Tickets wurden zusammen gekauft und können daher nur zusammen storniert und erstattet werden.',
                    removeParticipantWarning:
                        'Möchtest du diese:n Teilnehmende:n wirklich aus der Veranstaltung entfernen?',
                    removeOrganizerWarning:
                        'Möchtest du diese:n Organisator:in wirklich aus der Veranstaltung entfernen?',
                },
            },
        },
    },
    components: {
        CoRoundButton,
        CoHeadline,
        CoCard,
        CoInput,
        CoLink,
        CoUser,
        CoConfirmation,
    },
    props: {
        slug: {
            type: String,
            required: false,
            default: 'test',
        },
        me: {
            type: Object,
            required: false,
            default: () => ({}),
        },
        isPaymentsEnabled: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            event: {},
            createdBy: {},

            loadingParticipants: false,
            participants: [],

            loadingTaxRates: false,
            taxRates: [],

            currency: this.$store.state.space.Currency,
            searchInput: '',

            toRefund: null,
            refundLoading: false,
        };
    },
    watch: {
        event(oldVal, newVal) {
            if (newVal) {
                const amIorg = this.event.Organizers && this.event.Organizers.some((o) => o === this.me.ID);
                const amICreator = this.event.CreatedBy && this.me.ID === this.event.CreatedBy;
                const amIAdmin = get(this.me, 'Permissions', '').includes('space_admin');

                const canView = amIorg || amICreator || amIAdmin;
                if (!canView) {
                    this.$router.push(`/events/${this.slug}`);
                }
            }
        },
    },
    computed: {
        // if search input is empty, return all participants
        // if search input is not empty, return filtered participants by name or ticketcode
        participantsFiltered() {
            const tmp = this.participants.map((participant) => {
                if (!participant.PriceInCents) {
                    return {
                        ...participant,
                        Price: `0.00 ${this.currencyChar}`,
                    };
                }
                return {
                    ...participant,
                    Price: `${(participant.PriceInCents / 100).toFixed(2)} ${this.currencyChar}`,
                };
            });

            if (!this.searchInput) {
                return tmp;
            }

            return tmp.filter(
                (participant) =>
                    participant.UserName.toLowerCase().includes(this.searchInput.toLowerCase()) ||
                    participant.ID.toLowerCase().includes(this.searchInput.toLowerCase())
            );
        },
        currencyChar() {
            if (!this.currency) {
                return '€';
            }

            const currency = this.currency.toUpperCase();

            if (currency === 'EUR') {
                return '€';
            }
            if (currency === 'USD') {
                return '$';
            }

            return currency;
        },
        canIEdit() {
            return (this.amIorganising || this.amIAdmin) && !this.preview && this.event.SpaceID === this.me.SpaceID;
        },
        amIorganising() {
            return this.event.Organizers && this.event.Organizers.some((o) => o === this.me.ID);
        },
        amICreator() {
            return this.event.CreatedBy && this.me.ID === this.event.CreatedBy;
        },
        amIAdmin() {
            return get(this.me, 'Permissions', '').includes('space_admin');
        },
        ticketsSold() {
            let ticketsSold = clone(this.event.Tickets);
            if (!ticketsSold) {
                return [];
            }

            // add tax rate to tickets
            ticketsSold = ticketsSold.map((ticket) => {
                if (!ticket.SoldCount) {
                    ticket.SoldCount = 0;
                }

                if (!ticket.PriceInCents) {
                    ticket.PriceInCents = 0;
                }
                ticket.TaxRate = this.getTaxRateForTicket(ticket);
                ticket.Price = `${(ticket.PriceInCents / 100).toFixed(2)} ${this.currencyChar}`;
                ticket.TotalPrice = `${((ticket.PriceInCents * ticket.SoldCount) / 100).toFixed(2)} ${
                    this.currencyChar
                }`;
                return ticket;
            });

            return ticketsSold;
        },
        refundRelatedTickets() {
            const sessionId = this.toRefund?.AssociatedSessionID;
            if (!sessionId || !this.participants || this.participants.length === 0) {
                return [];
            }

            return this.participants.filter((participant) => participant.AssociatedSessionID === sessionId);
        },
    },
    created() {
        this.getEvent();

        if (this.amIAdmin) {
            this.getTaxRates();
        }
    },

    methods: {
        showRefundModal(itemToRefund) {
            this.toRefund = itemToRefund;
            this.$refs.refundmodal.show();
        },
        discardRefunding() {
            this.toRefund = null;
            this.$refs.refundmodal.hide();
        },
        ticketStatusLabel(status) {
            return this.$t(getTicketPurchaseStatusLabelKey(status));
        },
        // refund ticket
        refundTicket() {
            this.refundLoading = true;
            const req = {
                ticket_id: this.toRefund.ID,
                event_id: this.toRefund.EventID,
            };

            axios
                .post(`/event/organizer/ticket/refund`, req)
                .then(() => {
                    EventBus.$emit('INFO', {
                        Message: this.$t('messages.event.ticketRefundSuccess'),
                        Details: '',
                    });
                    this.getEvent();
                })
                .catch((error) => {
                    console.error(error);
                    EventBus.$emit('ERROR', {
                        Message: this.$t('messages.event.ticketRefundError'),
                        Details: '',
                    });
                })
                .finally(() => {
                    this.refundLoading = false;
                    this.toRefund = null;
                    this.$refs.refundmodal.hide();
                });
        },
        downloadCsv() {
            const tableData = this.$refs.participantstable?.getTableData();
            if (!tableData || tableData.length === 0) return;
            this.$refs.csvDownloader?.exportAsCSV(tableData);
        },
        backtToEvent() {
            this.$router.push(`/events/${this.event.Slug}`);
        },

        getTaxRateForTicket(ticket) {
            const taxrate = this.taxRates.find((taxrate) => taxrate.ID === ticket.TaxRateID);

            if (!taxrate) {
                return '-';
            }

            if (!taxrate.Percentage) {
                return '0%';
            }

            return `${taxrate.Percentage}%`;
        },

        isEnabled(feature) {
            if (!this.$unleash) {
                console.error('Unleash not available');
                return false;
            }
            return this.$unleash.isEnabled(feature);
        },

        get,
        map,
        upperFirst,
        toLower,
        async getEvent() {
            this.loadingEvent = true;
            try {
                const response = await axios.get(`/event/by-slug/${this.slug}`);
                this.event = response.data;
                this.getParticipants();
            } catch (error) {
                console.error(error);
            }
            this.loadingEvent = false;
        },

        async getParticipants() {
            this.loadingParticipants = true;

            try {
                const result = await axios({
                    method: 'GET',
                    url: `/event/participant/list/for-event-id/${this.event.ID}`,
                    withCredentials: true,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });
                this.participants = get(result, 'data.Participants', []);
                this.loadingParticipants = false;
            } catch (error) {
                console.log(error);
                this.loadingParticipants = false;
            }
        },

        getTaxRates() {
            this.loadingTaxRate = true;
            axios({
                method: 'GET',
                url: `/space/tax/list`,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    if (response && response.data) {
                        this.taxRates = response.data;
                    }
                    this.loadingTaxRate = false;
                })
                .catch((error) => {
                    this.loadingTaxRate = false;
                    console.log(error);
                });
        },
        getParticipantUserId(item) {
            return get(item, 'UserID', get(item, 'UserData.ID', null));
        },
        isTargetCreator(item) {
            const userId = this.getParticipantUserId(item);
            return !!userId && userId === this.event.CreatedBy;
        },
        isTargetOrganizer(item) {
            const userId = this.getParticipantUserId(item);
            return !!userId && this.event.Organizers && this.event.Organizers.includes(userId);
        },
        hasOriginalTicketType(item) {
            return !!get(item, 'OriginalTicketTypeID', null);
        },
        canRemoveParticipant(item) {
            if (!this.canIEdit || !item || this.hasOriginalTicketType(item)) {
                return false;
            }
            const userId = this.getParticipantUserId(item);
            if (!userId || userId === this.me.ID) {
                return false;
            }
            if (this.isTargetCreator(item)) {
                return false;
            }
            if (this.isTargetOrganizer(item)) {
                return false;
            }
            return true;
        },
        canRemoveOrganizer(item) {
            if (!this.canIEdit || !item || !this.amICreator) {
                return false;
            }
            const userId = this.getParticipantUserId(item);
            if (!userId || userId === this.me.ID) {
                return false;
            }
            if (this.isTargetCreator(item)) {
                return false;
            }
            return this.isTargetOrganizer(item);
        },
        removeParticipant(item) {
            const userId = this.getParticipantUserId(item);
            if (!userId) {
                return;
            }
            this.loadingParticipants = true;
            const request = {
                EventID: this.event.ID,
                ParticipantID: userId,
            };
            axios({
                method: 'DELETE',
                url: '/event/participant',
                data: request,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    if (response && response.data) {
                        this.event = response.data;
                        // remove participant from participants list to update the table
                        this.participants = this.participants.filter((p) => this.getParticipantUserId(p) !== userId);
                    }
                })
                .catch((error) => {
                    console.error(error);
                    EventBus.$emit('ERROR', {
                        Message: this.$t('labels.failedGeneric'),
                        Details: error,
                    });
                })
                .finally(() => {
                    this.loadingParticipants = false;
                });
        },
        removeOrganizerFromEvent(item) {
            const userId = this.getParticipantUserId(item);
            if (!userId) {
                return;
            }
            this.loadingParticipants = true;
            const updatedEvent = clone(this.event);
            updatedEvent.Organizers = (updatedEvent.Organizers || []).filter((o) => o !== userId);
            this.$store
                .dispatch('updateEvent', updatedEvent)
                .then((response) => {
                    if (response) {
                        this.event = response;
                    } else {
                        this.event = updatedEvent;
                    }
                    this.participants = this.participants.filter((p) => this.getParticipantUserId(p) !== userId);
                })
                .catch((error) => {
                    console.error(error);
                    EventBus.$emit('ERROR', {
                        Message: this.$t('labels.failedGeneric'),
                        Details: error,
                    });
                })
                .finally(() => {
                    this.loadingParticipants = false;
                });
        },
    },
};
